import { Component, OnInit } from '@angular/core';
import { PageComponent, PageService, Page } from '@tytapp/common';
import { ActivatedRoute } from '@angular/router';
import { Offer } from 'models/Offer';
import { MembershipProduct, VOD, Podcast, Production } from 'models';
import { LocalStorageService } from 'angular-2-local-storage';
import { ProductionsService } from '@tytapp/common-ui';
import { UserService } from 'user';
import { OffersApi } from '@tytapp/api';

@Page('payment-confirmation')
@Component({
  selector: 'tyt-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent extends PageComponent implements OnInit {
  constructor(
    private pageService : PageService,
    private route : ActivatedRoute,
    private localStorage : LocalStorageService,
    private productionsService : ProductionsService,
    private userService: UserService,
    private offersApi : OffersApi
  ) {
    super(pageService);
  }

  offer: Offer;
  membershipProduct: MembershipProduct;
  production: Production;
  episode: VOD;
  podcast: Podcast;
  offerSetUUID: string;
  offerUUID: string = null;
  premiumProductionId: string;
  audienceType: string = 'visitor';

  async init() {
    this.subscribe(this.route.paramMap, async params => {
      this.offerUUID = params.get('offerUUID');
      this.offerSetUUID = params.get('offerSetUUID');

      if (!this.offerUUID) {
        return;
      }

      try {
        this.offer = await this.offersApi.get(this.offerUUID).toPromise();
        this.membershipProduct = <MembershipProduct>this.offer.membership_product;
      } catch(e) {
        console.error('Error while fetching offer:');
        console.error(e);
      }
      this.premiumProductionId = this.localStorage.get('productionId');

      if (this.premiumProductionId) {
        this.production = await this.productionsService.get(this.premiumProductionId);

        if (this.production) {
          if (this.localStorage.get('productionContentType') === 'episode') {
            let index = this.localStorage.get('productionContentIndex') as number;
            this.episode = this.production.full_length_vods[index];
            this.production.full_length_vods = [this.episode];
          }

          if (this.localStorage.get('productionContentType') === 'podcast') {
            let index = this.localStorage.get('productionContentIndex') as number;
            this.podcast = this.production.full_length_podcasts[index];
            this.production.full_length_podcasts = [this.podcast];
          }
        }
      } else {
        // redirect them somewhere
      }

      this.audienceType = this.userService.audienceType;

      // Change out the URL shown in the URL bar to ensure that reloads / history 
      // navigation does not retrigger page views on this page (because we use 
      // page view analytics to track conversions)

      if (typeof window !== 'undefined') {
        setTimeout(() => {
          history.replaceState(undefined, "TYT.com", "/?postpurchase");
        }, 10*1000)
      }
    })
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

}
